import { useEffect, useState } from 'react';
import { NetworkProvider } from '@/providers/NetworkProvider';
import { HackerDashboard } from '@/components/HackerDashboard';
import { Toaster } from 'react-hot-toast';
import '@/i18n/config'; // Initialize i18n
import '@/styles/splash-gate.css';
import '@/styles/toast.css';

export default function App() {
  const [accepted, setAccepted] = useState(false);
  const network = (import.meta.env.VITE_NETWORK || 'mordor').toLowerCase();
  const isMordor = network === 'mordor';

  const splashKicker =
    import.meta.env.VITE_SPLASH_KICKER ||
    (isMordor ? 'Node Empire Test Build' : 'Welcome to Node Empire');
  const splashTitle =
    import.meta.env.VITE_SPLASH_TITLE ||
    (isMordor ? 'Mordor Testnet Access' : 'Welcome to Node Empire');
  const splashLead =
    import.meta.env.VITE_SPLASH_LEAD ||
    (isMordor
      ? 'You are entering a live test deployment on ETC Mordor (chainId 63). Values and balance can change during development.'
      : 'Node Empire is an ETC Classic game by ETCMCv2 where you can earn ETCPOWv2 while playing.');
  const splashFoot =
    import.meta.env.VITE_SPLASH_FOOTER ||
    (isMordor
      ? 'Testing mode: expect resets, updates and balancing changes.'
      : 'Primary focus is gameplay. Rewards are part of progression.');

  useEffect(() => {
    const noticeKey = `nodeEmpireNoticeAccepted:${network}`;
    setAccepted(localStorage.getItem(noticeKey) === '1');
  }, [network]);

  const acceptWarning = () => {
    localStorage.setItem(`nodeEmpireNoticeAccepted:${network}`, '1');
    setAccepted(true);
  };

  if (!accepted) {
    return (
      <div className="splash-gate">
        <div className="splash-card">
          <div className="splash-brand">NODE EMPIRE</div>
          <div className="splash-kicker">{splashKicker}</div>
          <h1 className="splash-title">{splashTitle}</h1>
          <div className="splash-chip-row">
            <span className="splash-chip etc">Ethereum Classic</span>
            <span className="splash-chip">Network: {isMordor ? 'Mordor' : 'ETC Mainnet'}</span>
            <span className="splash-chip">ChainId: {isMordor ? '63' : '61'}</span>
            <span className="splash-chip">{isMordor ? 'Gas: METC' : 'Gas: ETC'}</span>
          </div>
          <p className="splash-text">
            {splashLead}
          </p>
          <ul className="splash-list">
            <li>Built for Ethereum Classic — not Ethereum mainnet or L2s.</li>
            <li>Earn ETCPOWv2 by running virtual nodes, opening chests, and climbing the leaderboard.</li>
            <li>{isMordor ? 'Use Mordor test funds (METC + ETCPOWv2) only.' : 'Confirm your wallet is on ETC mainnet (61).'}</li>
            <li>Chests open one block after purchase — buy in Shop, open in Inventory.</li>
          </ul>
          <div className="splash-foot">{splashFoot}</div>
          <button type="button" className="splash-accept" onClick={acceptWarning}>
            {isMordor ? 'Enter Mordor Test Build' : 'Enter Node Empire'}
          </button>
        </div>
      </div>
    );
  }

  return (
    <NetworkProvider>
      <HackerDashboard />
      <Toaster
        position="top-right"
        gutter={10}
        containerStyle={{ top: 72, right: 16 }}
        toastOptions={{
          className: 'ne-toast',
          duration: 3800,
          success: { className: 'ne-toast ne-toast-success', duration: 3200 },
          error: { className: 'ne-toast ne-toast-error', duration: 4500 },
          loading: { className: 'ne-toast ne-toast-loading' },
          style: {
            background: 'rgba(4, 20, 15, 0.96)',
            color: '#e6fff4',
            border: '1px solid rgba(0, 255, 136, 0.28)',
            borderRadius: '14px',
            fontFamily: "'IBM Plex Mono', Consolas, monospace",
            fontSize: '13px',
            boxShadow: '0 18px 40px rgba(0, 0, 0, 0.45)',
          },
        }}
      />
    </NetworkProvider>
  );
}
